import type { MemorySliceDescriptor } from "../../shared";
import { bikeStationPopupRequestSlice } from "./bikeStationPopupRequest.slice";
import { drawnItineraryGeometrySlice } from "./drawnItineraryGeometry.slice";
import { exchangeRateSessionSlice } from "./exchangeRateSession.slice";
import { itineraryPanelStateSlice } from "./itineraryPanelState.slice";
import { mapReadySlice } from "./mapReady.slice";
import { navigationSessionSlice } from "./navigationSession.slice";
import { routeHistorySlice } from "./routeHistory.slice";

/**
 * Complete registry of ephemeral session slices.
 */
export const ALL_EPHEMERAL_SLICES = [
    mapReadySlice,
    drawnItineraryGeometrySlice,
    navigationSessionSlice,
    itineraryPanelStateSlice,
    routeHistorySlice,
    exchangeRateSessionSlice,
    bikeStationPopupRequestSlice,
] as const satisfies readonly MemorySliceDescriptor<unknown>[];
